import { PAGE_NAV_SHADOW_HEIGHT } from 'Utils/constants';
import { GetBreakpointWidth } from 'Utils/globals-bp';

export function InitScript_searchSingleResult() {
    if (!searchViewModel.isSingleResults())
        return;

    //// If we are on a hotel page, and the query parameters are filled out - do the search
    //if (AppData.CurrentHotelId != null && getParameterByName("departure") != "") {
    //    // For some reason, firing right away does not work. Look into this later.
    //    setTimeout(function () {
    //        searchViewModel.RequestSearch(false);
    //    }, 2000);
    //
    //}

    if (searchViewModel.IsHotel()) {
        // 2018-01-15 Use CurrentPageId to show HotelName in SearchBar.DestinationID
        //searchViewModel.PageID(AppData.CurrentParentId);

        setTimeout(function () {
            searchViewModel.RequestSearch(false);
        }, 2000);

        $(document).on('click', '.price_mail_click', function () {
            if (searchViewModel && searchViewModel.SingleHotelResult() && searchViewModel.PriceRequest()) {
                searchViewModel.PriceRequest().ShowAlert(searchViewModel.SingleHotelResult());
            }
        });

        //2017-03-21 detached scrolling on hotel page
        //if (searchViewModel.DepartureDate() && searchViewModel.ReturnDate()) {
        //    scrollToHotelSearchBox(2000, 1000);
        //}
        /*
        var headers = document.getElementsByClassName("header");
        if (headers != null && headers.length > 0) {
            ko.applyBindings(searchViewModel, headers[0]);
        }
        */
        /*
        var bubble = $(".from-bubble.search-spec-package");
        if (bubble && bubble.length > 0) {
            var holder = bubble.parent();
            if (holder && holder.length > 0) {
                if ($('.hotelpage').length == 0) {
                    if (getParameterByName("departure") != "" && getParameterByName("return") != "") {
                        holder.hide();
                    } else {
                        holder.show();
                    }
                } else {
                    holder.show();
                }
            }
        }
        */
    }

    // FIXME !!! legacy script :: 'on click .hotel-searchbutton' is not used for now
    //$('.hotel-searchbutton').click(function () {
    //    // Make sure dates are filled
    //    if (searchViewModel.DepartureDate() == null || searchViewModel.ReturnDate() == null) {
    //        $('.hotel-search-box .validate').show();
    //    } else {
    //        $('.hotel-search-box .validate').hide();
    //        updateQueryStringWithoutHistory();
    //        searchViewModel.RequestSearch(true);
    //    }
    //});

    $(document).on('click', '.hotelpage .go-next', function (e) {
        if (searchViewModel.IsHotel()) {
            var currentStep = searchViewModel.ProcessWizard().CurrentStep();
            var flgValid = searchViewModel.MyTripValidator().ValidateStep(currentStep);
            if (!flgValid) {
                e.preventDefault();
                return false;
            }

        }
    });

    //2017-03-21 detached scrolling on hotel page
    //$(document).on('click', '.room-box', function (e) {
    //    var roomTypeId = $(this).data('room-type-id');
    //    if (roomTypeId) {
    //        searchViewModel.SelectedRoomTypeId(roomTypeId);
    //        scrollToHotelSearchBox();
    //    } else {
    //        searchViewModel.SelectedRoomTypeId(-1);
    //    }
    //});


    
};

// FIXME !!! legacy script :: 'positionRoomsSelector' is not used for now
//export function positionRoomsSelector(event) {
//    var tPosX = event.pageX - 10;
//    var tPosY = event.pageY - 100;
//    $('div.tooltip').css({ 'position': 'absolute', 'top': tPosY, 'left': tPosX });
//};

// FIXME !!! legacy script :: 'scrollToHotelSearchBox' is not used for now
//export function scrollToHotelSearchBox(delayDuration, animateDuration) {
//    if (!delayDuration)
//        delayDuration = 0;
//    if (!animateDuration)
//        animateDuration = 300;
//    //Scroll to parent div because 'hotel-search-box' is used with ScrollToFixed
//    //When scroll from 'lower part of page' that it is not in good location
//    var searchBox = $(".hotel-search-box:first");
//    $('html, body').stop().delay(delayDuration).animate({
//        scrollTop: $("section#description").offset().top - 80
//    }, animateDuration);
//
//    //var searchBox = $(".hotel-search-box:first");
//    //$('html, body').stop().animate({
//    //    //* scroll to search bar at the top of window
//    //    scrollTop: searchBox.offset().top - 80
//    //    //* scroll to search bar at the bottom of window
//    //    //scrollTop: searchBox.offset().top - 80 - searchBox.outerHeight()
//    //}, 300);
//};

export function scrollToHotelSearchBar(delayDuration, animateDuration) {
    if (!delayDuration)
        delayDuration = 0;
    if (!animateDuration)
        animateDuration = 300;

    var topMenu = $(".page-nav");
    var topMenuHeight = 0;
    if (topMenu.length > 0) {
        var shadowHeight = PAGE_NAV_SHADOW_HEIGHT;
        topMenuHeight = topMenu.outerHeight(true) + shadowHeight;
    }

    var searchBox = $(".searchbar-static:first");
    if (searchBox) {
        $('html, body').stop().delay(delayDuration).animate({
            scrollTop: searchBox.offset().top - topMenuHeight
        }, animateDuration);
    }
};

export function scrollToHotelPrices(delayDuration, animateDuration) {
    if (!delayDuration)
        delayDuration = 0;
    if (!animateDuration)
        animateDuration = 300;

    var topMenu = $(".page-nav");
    var topMenuHeight = 0;
    if (topMenu.length > 0 && topMenu.is(":visible") || topMenu.css("display") != 'none') {
        topMenuHeight = topMenu.outerHeight(true) - 1;
    }
    let offset = 10;
    let $target_mobile = (GetBreakpointWidth() < 768) ? $("#hotel-prices-mobile-anchor") : null;
    var $target = ($target_mobile && $target_mobile.length > 0) ? $target_mobile : $("#prices");
    if ($target && $target.length > 0) {
        $('html, body').stop().delay(delayDuration).animate({
            scrollTop: $target.offset().top - topMenuHeight - offset
        }, animateDuration);
    }
};
